// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
 .quill {
    height: 100%;
    display: flex;
    flex-direction: column;
 }
 .ql-container {
    box-sizing: border-box;
    font-size: 16px;
    height: 100%;
    margin: 0px;
    position: relative;
  }
  .ql-container.ql-disabled .ql-tooltip {
    visibility: hidden;
  }
  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {
    pointer-events: none;
  }
  .ql-clipboard {
    left: -100000px;
    height: 1px;
    overflow-y: hidden;
    position: absolute;
    top: 50%;
  }
  .ql-clipboard p {
    margin: 0;
    padding: 0;
  }
  .ql-editor {
    box-sizing: border-box;
    line-height: 1.42;
    height: 100%;
    outline: none;
    overflow-y: auto;
    padding: 12px 15px;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
  }
  .ql-editor > * {
    cursor: text;
  }
  .ql-editor p,
  .ql-editor ol,
  .ql-editor ul,
  .ql-editor pre,
  .ql-editor blockquote,
  .ql-editor h1,
  .ql-editor h2,
  .ql-editor h3,
  .ql-editor h4,
  .ql-editor h5,
  .ql-editor h6 {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em;
  }
  .ql-editor ol > li,
  .ql-editor ul > li {
    list-style-type: none;
  }
  .ql-editor ul > li::before {
    content: '\\2022';
  }
  .ql-editor ul[data-checked=true],
  .ql-editor ul[data-checked=false] {
    pointer-events: none;
  }
  .ql-editor ul[data-checked=true] > li *,
  .ql-editor ul[data-checked=false] > li * {
    pointer-events: all;
  }
  .ql-editor ul[data-checked=true] > li::before,
  .ql-editor ul[data-checked=false] > li::before {
    color: #777;
    cursor: pointer;
    pointer-events: all;
  }
  .ql-editor ul[data-checked=true] > li::before {
    content: '\\2611';
  }
  .ql-editor ul[data-checked=false] > li::before {
    content: '\\2610';
  }
  .ql-editor li::before {
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  .ql-editor li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
  }
  .ql-editor li.ql-direction-rtl::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
  }
  .ql-editor ol li:not(.ql-direction-rtl),
  .ql-editor ul li:not(.ql-direction-rtl) {
    padding-left: 1.5em;
  }
  .ql-editor ol li.ql-direction-rtl,
  .ql-editor ul li.ql-direction-rtl {
    padding-right: 1.5em;
  }
  .ql-editor ol li {
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    counter-increment: list-0;
  }
  .ql-editor ol li:before {
    content: counter(list-0, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-increment: list-1;
  }
  .ql-editor ol li.ql-indent-1:before {
    content: counter(list-1, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-1 {
    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-2 {
    counter-increment: list-2;
  }
  .ql-editor ol li.ql-indent-2:before {
    content: counter(list-2, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-2 {
    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-3 {
    counter-increment: list-3;
  }
  .ql-editor ol li.ql-indent-3:before {
    content: counter(list-3, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-3 {
    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-4 {
    counter-increment: list-4;
  }
  .ql-editor ol li.ql-indent-4:before {
    content: counter(list-4, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-4 {
    counter-reset: list-5 list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-5 {
    counter-increment: list-5;
  }
  .ql-editor ol li.ql-indent-5:before {
    content: counter(list-5, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-5 {
    counter-reset: list-6 list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-6 {
    counter-increment: list-6;
  }
  .ql-editor ol li.ql-indent-6:before {
    content: counter(list-6, decimal) '. ';
  }
  .ql-editor ol li.ql-indent-6 {
    counter-reset: list-7 list-8 list-9;
  }
  .ql-editor ol li.ql-indent-7 {
    counter-increment: list-7;
  }
  .ql-editor ol li.ql-indent-7:before {
    content: counter(list-7, lower-alpha) '. ';
  }
  .ql-editor ol li.ql-indent-7 {
    counter-reset: list-8 list-9;
  }
  .ql-editor ol li.ql-indent-8 {
    counter-increment: list-8;
  }
  .ql-editor ol li.ql-indent-8:before {
    content: counter(list-8, lower-roman) '. ';
  }
  .ql-editor ol li.ql-indent-8 {
    counter-reset: list-9;
  }
  .ql-editor ol li.ql-indent-9 {
    counter-increment: list-9;
  }
  .ql-editor ol li.ql-indent-9:before {
    content: counter(list-9, decimal) '. ';
  }
  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 3em;
  }
  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 4.5em;
  }
  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 3em;
  }
  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
    padding-right: 4.5em;
  }
  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 6em;
  }
  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 7.5em;
  }
  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 6em;
  }
  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
    padding-right: 7.5em;
  }
  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 9em;
  }
  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 10.5em;
  }
  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 9em;
  }
  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
    padding-right: 10.5em;
  }
  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 12em;
  }
  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 13.5em;
  }
  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 12em;
  }
  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
    padding-right: 13.5em;
  }
  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 15em;
  }
  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 16.5em;
  }
  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 15em;
  }
  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
    padding-right: 16.5em;
  }
  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 18em;
  }
  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 19.5em;
  }
  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 18em;
  }
  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
    padding-right: 19.5em;
  }
  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 21em;
  }
  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 22.5em;
  }
  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 21em;
  }
  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
    padding-right: 22.5em;
  }
  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 24em;
  }
  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 25.5em;
  }
  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 24em;
  }
  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
    padding-right: 25.5em;
  }
  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 27em;
  }
  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 28.5em;
  }
  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 27em;
  }
  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
    padding-right: 28.5em;
  }
  .ql-editor .ql-video {
    display: block;
    max-width: 100%;
  }
  .ql-editor .ql-video.ql-align-center {
    margin: 0 auto;
  }
  .ql-editor .ql-video.ql-align-right {
    margin: 0 0 0 auto;
  }
  .ql-editor .ql-bg-black {
    background-color: #000;
  }
  .ql-editor .ql-bg-red {
    background-color: #e60000;
  }
  .ql-editor .ql-bg-orange {
    background-color: #f90;
  }
  .ql-editor .ql-bg-yellow {
    background-color: #ff0;
  }
  .ql-editor .ql-bg-green {
    background-color: #008a00;
  }
  .ql-editor .ql-bg-blue {
    background-color: #06c;
  }
  .ql-editor .ql-bg-purple {
    background-color: #93f;
  }
  .ql-editor .ql-color-white {
    color: #fff;
  }
  .ql-editor .ql-color-red {
    color: #e60000;
  }
  .ql-editor .ql-color-orange {
    color: #f90;
  }
  .ql-editor .ql-color-yellow {
    color: #ff0;
  }
  .ql-editor .ql-color-green {
    color: #008a00;
  }
  .ql-editor .ql-color-blue {
    color: #06c;
  }
  .ql-editor .ql-color-purple {
    color: #93f;
  }
  .ql-editor .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-editor .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-editor .ql-size-small {
    font-size: 0.75em;
  }
  .ql-editor .ql-size-large {
    font-size: 1.5em;
  }
  .ql-editor .ql-size-huge {
    font-size: 2.5em;
  }
  .ql-editor .ql-direction-rtl {
    direction: rtl;
    text-align: inherit;
  }
  .ql-editor .ql-align-center {
    text-align: center;
  }
  .ql-editor .ql-align-justify {
    text-align: justify;
  }
  .ql-editor .ql-align-right {
    text-align: right;
  }
  .ql-editor.ql-blank::before {
    color: rgba(0,0,0,0.6);
    content: attr(data-placeholder);
    font-style: italic;
    left: 15px;
    pointer-events: none;
    position: absolute;
    right: 15px;
  }
  .ql-snow.ql-toolbar:after,
  .ql-snow .ql-toolbar:after {
    clear: both;
    content: '';
    display: table;
  }
  .ql-snow.ql-toolbar button,
  .ql-snow .ql-toolbar button {
    background: none;
    border: none;
    cursor: pointer;
    display: inline-block;
    float: left;
    height: 24px;
    padding: 3px 5px;
    width: 28px;
  }
  .ql-snow.ql-toolbar button svg,
  .ql-snow .ql-toolbar button svg {
    float: left;
    height: 100%;
  }
  .ql-snow.ql-toolbar button:active:hover,
  .ql-snow .ql-toolbar button:active:hover {
    outline: none;
  }
  .ql-snow.ql-toolbar input.ql-image[type=file],
  .ql-snow .ql-toolbar input.ql-image[type=file] {
    display: none;
  }
  .ql-snow.ql-toolbar button:hover,
  .ql-snow .ql-toolbar button:hover,
  .ql-snow.ql-toolbar button:focus,
  .ql-snow .ql-toolbar button:focus,
  .ql-snow.ql-toolbar button.ql-active,
  .ql-snow .ql-toolbar button.ql-active,
  .ql-snow.ql-toolbar .ql-picker-label:hover,
  .ql-snow .ql-toolbar .ql-picker-label:hover,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active,
  .ql-snow.ql-toolbar .ql-picker-item:hover,
  .ql-snow .ql-toolbar .ql-picker-item:hover,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
    color: #06c;
  }
  .ql-snow.ql-toolbar button:hover .ql-fill,
  .ql-snow .ql-toolbar button:hover .ql-fill,
  .ql-snow.ql-toolbar button:focus .ql-fill,
  .ql-snow .ql-toolbar button:focus .ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
  .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
    fill: #06c;
  }
  .ql-snow.ql-toolbar button:hover .ql-stroke,
  .ql-snow .ql-toolbar button:hover .ql-stroke,
  .ql-snow.ql-toolbar button:focus .ql-stroke,
  .ql-snow .ql-toolbar button:focus .ql-stroke,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
  .ql-snow.ql-toolbar button:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar button:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar button:focus .ql-stroke-miter,
  .ql-snow .ql-toolbar button:focus .ql-stroke-miter,
  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
    stroke: #06c;
  }
  @media (pointer: coarse) {
    .ql-snow.ql-toolbar button:hover:not(.ql-active),
    .ql-snow .ql-toolbar button:hover:not(.ql-active) {
      color: #FFF;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {
      fill: #FFF;
    }
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,
    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,
    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {
      stroke: #FFF;
    }
  }
  .ql-snow {
    box-sizing: border-box;
  }
  .ql-snow * {
    box-sizing: border-box;
  }
  .ql-snow .ql-hidden {
    display: none;
  }
  .ql-snow .ql-out-bottom,
  .ql-snow .ql-out-top {
    visibility: hidden;
  }
  .ql-snow .ql-tooltip {
    position: absolute;
    transform: translateY(10px);
  }
  .ql-snow .ql-tooltip a {
    cursor: pointer;
    text-decoration: none;
  }
  .ql-snow .ql-tooltip.ql-flip {
    transform: translateY(-10px);
  }
  .ql-snow .ql-formats {
    display: inline-block;
    vertical-align: middle;
  }
  .ql-snow .ql-formats:after {
    clear: both;
    content: '';
    display: table;
  }
  .ql-snow .ql-stroke {
    fill: none;
    stroke: #FFF;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 2;
  }
  .ql-snow .ql-stroke-miter {
    fill: none;
    stroke: #FFF;
    stroke-miterlimit: 10;
    stroke-width: 2;
  }
  .ql-snow .ql-fill,
  .ql-snow .ql-stroke.ql-fill {
    fill: #FFF;
  }
  .ql-snow .ql-empty {
    fill: none;
  }
  .ql-snow .ql-even {
    fill-rule: evenodd;
  }
  .ql-snow .ql-thin,
  .ql-snow .ql-stroke.ql-thin {
    stroke-width: 1;
  }
  .ql-snow .ql-transparent {
    opacity: 0.4;
  }
  .ql-snow .ql-direction svg:last-child {
    display: none;
  }
  .ql-snow .ql-direction.ql-active svg:last-child {
    display: inline;
  }
  .ql-snow .ql-direction.ql-active svg:first-child {
    display: none;
  }
  .ql-snow .ql-editor h1 {
    font-size: 2em;
  }
  .ql-snow .ql-editor h2 {
    font-size: 1.5em;
  }
  .ql-snow .ql-editor h3 {
    font-size: 1.17em;
  }
  .ql-snow .ql-editor h4 {
    font-size: 1em;
  }
  .ql-snow .ql-editor h5 {
    font-size: 0.83em;
  }
  .ql-snow .ql-editor h6 {
    font-size: 0.67em;
  }
  .ql-snow .ql-editor a {
    text-decoration: underline;
  }
  .ql-snow .ql-editor blockquote {
    border-left: 4px solid #ccc;
    margin-bottom: 5px;
    margin-top: 5px;
    padding-left: 16px;
  }
  .ql-snow .ql-editor code,
  .ql-snow .ql-editor pre {
    background-color: #f0f0f0;
    border-radius: 3px;
  }
  .ql-snow .ql-editor pre {
    white-space: pre-wrap;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 10px;
  }
  .ql-snow .ql-editor code {
    font-size: 85%;
    padding: 2px 4px;
  }
  .ql-snow .ql-editor pre.ql-syntax {
    background-color: #23241f;
    color: #f8f8f2;
    overflow: visible;
  }
  .ql-snow .ql-editor img {
    max-width: 100%;
  }
  .ql-snow .ql-picker {
    color: #FFF;
    display: inline-block;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    position: relative;
    vertical-align: middle;
  }
  .ql-snow .ql-picker-label {
    cursor: pointer;
    display: inline-block;
    height: 100%;
    padding-left: 8px;
    padding-right: 2px;
    position: relative;
    width: 100%;
  }
  .ql-snow .ql-picker-label::before {
    display: inline-block;
    line-height: 22px;
  }
  .ql-snow .ql-picker-options {
    background-color: #293742;
    display: none;
    min-width: 100%;
    padding: 4px 8px;
    position: absolute;
    white-space: nowrap;
  }
  .ql-snow .ql-picker-options .ql-picker-item {
    cursor: pointer;
    display: block;
    padding-bottom: 5px;
    padding-top: 5px;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label {
    color: #ccc;
    z-index: 2;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
    fill: #ccc;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
    stroke: #ccc;
  }
  .ql-snow .ql-picker.ql-expanded .ql-picker-options {
    display: block;
    margin-top: -1px;
    top: 100%;
    z-index: 1;
  }
  .ql-snow .ql-color-picker,
  .ql-snow .ql-icon-picker {
    width: 28px;
  }
  .ql-snow .ql-color-picker .ql-picker-label,
  .ql-snow .ql-icon-picker .ql-picker-label {
    padding: 2px 4px;
  }
  .ql-snow .ql-color-picker .ql-picker-label svg,
  .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
  }
  .ql-snow .ql-icon-picker .ql-picker-options {
    padding: 4px 0px;
  }
  .ql-snow .ql-icon-picker .ql-picker-item {
    height: 24px;
    width: 24px;
    padding: 2px 4px;
  }
  .ql-snow .ql-color-picker .ql-picker-options {
    padding: 3px 5px;
    width: 152px;
  }
  .ql-snow .ql-color-picker .ql-picker-item {
    border: 0px solid transparent;
    float: left;
    height: 16px;
    margin: 2px;
    padding: 0px;
    width: 16px;
  }
  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
    position: absolute;
    margin-top: -9px;
    right: 0;
    top: 50%;
    width: 18px;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
  }
  .ql-snow .ql-picker.ql-header {
    width: 98px;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: 'Normal';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: 'Heading 1';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: 'Heading 2';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: 'Heading 3';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: 'Heading 4';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: 'Heading 5';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: 'Heading 6';
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    font-size: 2em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    font-size: 1.5em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    font-size: 1.17em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    font-size: 1em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    font-size: 0.83em;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    font-size: 0.67em;
  }
  .ql-snow .ql-picker.ql-font {
    width: 108px;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: 'Sans Serif';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: 'Serif';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: 'Monospace';
  }
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    font-family: Georgia, Times New Roman, serif;
  }
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    font-family: Monaco, Courier New, monospace;
  }
  .ql-snow .ql-picker.ql-size {
    width: 98px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: 'Normal';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: 'Small';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: 'Large';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: 'Huge';
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    font-size: 10px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    font-size: 18px;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    font-size: 32px;
  }
  .ql-snow .ql-color-picker.ql-background .ql-picker-item {
    background-color: #fff;
  }
  .ql-snow .ql-color-picker.ql-color .ql-picker-item {
    background-color: #000;
  }
  .ql-toolbar.ql-snow {
    border: 0px solid #ccc;
    background-color: #394b59!important;
    box-sizing: border-box;
    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    padding: 8px;
  }
  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 15px;
  }
  .ql-toolbar.ql-snow .ql-picker-label {
    border: 0px solid transparent;
  }
  .ql-toolbar.ql-snow .ql-picker-options {
    border: 0px solid transparent;
    box-shadow: rgba(0,0,0,0.2) 0 2px 8px;
  }
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
    border-color: #ccc;
  }
  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    border-color: #ccc;
  }
  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
    border-color: #000;
  }
  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: 0px;
  }
  .ql-snow .ql-tooltip {
    background-color: #293742;
    border: 0px solid #ccc;
    box-shadow: 0px 0px 5px #ddd;
    color: #FFF;
    padding: 5px 12px;
    white-space: nowrap;
  }
  .ql-snow .ql-tooltip::before {
    content: "Visit URL:";
    line-height: 26px;
    margin-right: 8px;
  }
  .ql-snow .ql-tooltip input[type=text] {
    display: none;
    border: 0px solid #ccc;
    font-size: 13px;
    height: 26px;
    margin: 0px;
    padding: 3px 5px;
    width: 170px;
  }
  .ql-snow .ql-tooltip a.ql-preview {
    display: inline-block;
    max-width: 200px;
    overflow-x: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }
  .ql-snow .ql-tooltip a.ql-action::after {
    border-right: 1px solid #ccc;
    content: 'Edit';
    margin-left: 16px;
    padding-right: 8px;
  }
  .ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Remove';
    margin-left: 8px;
  }
  .ql-snow .ql-tooltip a {
    line-height: 26px;
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-preview,
  .ql-snow .ql-tooltip.ql-editing a.ql-remove {
    display: none;
  }
  .ql-snow .ql-tooltip.ql-editing input[type=text] {
    display: inline-block;
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: 'Save';
    padding-right: 0px;
  }
  .ql-snow .ql-tooltip[data-mode=link]::before {
    content: "Enter link:";
  }
  .ql-snow .ql-tooltip[data-mode=formula]::before {
    content: "Enter formula:";
  }
  .ql-snow .ql-tooltip[data-mode=video]::before {
    content: "Enter video:";
  }
  .ql-snow a {
    color: #06c;
  }
  .ql-container.ql-snow {
    border: 0px solid #ccc;
  }
  `, "",{"version":3,"sources":["webpack://./src/Quill.css"],"names":[],"mappings":"AAAA;;;;;EAKE;CACD;IACG,YAAY;IACZ,aAAa;IACb,sBAAsB;CACzB;CACA;IACG,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;EACV;EACA;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;;;;;;;;;;;IAWE,SAAS;IACT,UAAU;IACV,6EAA6E;EAC/E;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,6EAA6E;IAC7E,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,sEAAsE;EACxE;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,+DAA+D;EACjE;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,wDAAwD;EAC1D;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,iDAAiD;EACnD;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,qBAAqB;EACvB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;EACb;EACA;;IAEE,WAAW;IACX,WAAW;IACX,cAAc;EAChB;EACA;;IAEE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,aAAa;EACf;EACA;;;;;;;;;;;;;;IAcE,WAAW;EACb;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BE,UAAU;EACZ;EACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;IA4BE,YAAY;EACd;EACA;IACE;;MAEE,WAAW;IACb;IACA;;;;MAIE,UAAU;IACZ;IACA;;;;MAIE,YAAY;IACd;EACF;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,eAAe;IACf,qBAAqB;EACvB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,cAAc;EAChB;EACA;IACE,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,UAAU;EACZ;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,QAAQ;IACR,WAAW;EACb;EACA;;;;;;IAME,yBAAyB;EAC3B;EACA;IACE,WAAW;EACb;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;;IAEE,qBAAqB;EACvB;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,oBAAoB;EACtB;EACA;IACE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,WAAW;EACb;EACA;;IAEE,iBAAiB;EACnB;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,mCAAmC;IACnC,sBAAsB;IACtB,+DAA+D;IAC/D,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;IAC7B,qCAAqC;EACvC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;EACxB","sourcesContent":["/*!\n * Quill Editor v1.3.7\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */\n .quill {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n }\n .ql-container {\n    box-sizing: border-box;\n    font-size: 16px;\n    height: 100%;\n    margin: 0px;\n    position: relative;\n  }\n  .ql-container.ql-disabled .ql-tooltip {\n    visibility: hidden;\n  }\n  .ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n    pointer-events: none;\n  }\n  .ql-clipboard {\n    left: -100000px;\n    height: 1px;\n    overflow-y: hidden;\n    position: absolute;\n    top: 50%;\n  }\n  .ql-clipboard p {\n    margin: 0;\n    padding: 0;\n  }\n  .ql-editor {\n    box-sizing: border-box;\n    line-height: 1.42;\n    height: 100%;\n    outline: none;\n    overflow-y: auto;\n    padding: 12px 15px;\n    tab-size: 4;\n    -moz-tab-size: 4;\n    text-align: left;\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n  .ql-editor > * {\n    cursor: text;\n  }\n  .ql-editor p,\n  .ql-editor ol,\n  .ql-editor ul,\n  .ql-editor pre,\n  .ql-editor blockquote,\n  .ql-editor h1,\n  .ql-editor h2,\n  .ql-editor h3,\n  .ql-editor h4,\n  .ql-editor h5,\n  .ql-editor h6 {\n    margin: 0;\n    padding: 0;\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol,\n  .ql-editor ul {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol > li,\n  .ql-editor ul > li {\n    list-style-type: none;\n  }\n  .ql-editor ul > li::before {\n    content: '\\2022';\n  }\n  .ql-editor ul[data-checked=true],\n  .ql-editor ul[data-checked=false] {\n    pointer-events: none;\n  }\n  .ql-editor ul[data-checked=true] > li *,\n  .ql-editor ul[data-checked=false] > li * {\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before,\n  .ql-editor ul[data-checked=false] > li::before {\n    color: #777;\n    cursor: pointer;\n    pointer-events: all;\n  }\n  .ql-editor ul[data-checked=true] > li::before {\n    content: '\\2611';\n  }\n  .ql-editor ul[data-checked=false] > li::before {\n    content: '\\2610';\n  }\n  .ql-editor li::before {\n    display: inline-block;\n    white-space: nowrap;\n    width: 1.2em;\n  }\n  .ql-editor li:not(.ql-direction-rtl)::before {\n    margin-left: -1.5em;\n    margin-right: 0.3em;\n    text-align: right;\n  }\n  .ql-editor li.ql-direction-rtl::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n  }\n  .ql-editor ol li:not(.ql-direction-rtl),\n  .ql-editor ul li:not(.ql-direction-rtl) {\n    padding-left: 1.5em;\n  }\n  .ql-editor ol li.ql-direction-rtl,\n  .ql-editor ul li.ql-direction-rtl {\n    padding-right: 1.5em;\n  }\n  .ql-editor ol li {\n    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    counter-increment: list-0;\n  }\n  .ql-editor ol li:before {\n    content: counter(list-0, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-increment: list-1;\n  }\n  .ql-editor ol li.ql-indent-1:before {\n    content: counter(list-1, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-1 {\n    counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-increment: list-2;\n  }\n  .ql-editor ol li.ql-indent-2:before {\n    content: counter(list-2, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-2 {\n    counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-increment: list-3;\n  }\n  .ql-editor ol li.ql-indent-3:before {\n    content: counter(list-3, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-3 {\n    counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-increment: list-4;\n  }\n  .ql-editor ol li.ql-indent-4:before {\n    content: counter(list-4, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-4 {\n    counter-reset: list-5 list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-increment: list-5;\n  }\n  .ql-editor ol li.ql-indent-5:before {\n    content: counter(list-5, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-5 {\n    counter-reset: list-6 list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-increment: list-6;\n  }\n  .ql-editor ol li.ql-indent-6:before {\n    content: counter(list-6, decimal) '. ';\n  }\n  .ql-editor ol li.ql-indent-6 {\n    counter-reset: list-7 list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-increment: list-7;\n  }\n  .ql-editor ol li.ql-indent-7:before {\n    content: counter(list-7, lower-alpha) '. ';\n  }\n  .ql-editor ol li.ql-indent-7 {\n    counter-reset: list-8 list-9;\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-increment: list-8;\n  }\n  .ql-editor ol li.ql-indent-8:before {\n    content: counter(list-8, lower-roman) '. ';\n  }\n  .ql-editor ol li.ql-indent-8 {\n    counter-reset: list-9;\n  }\n  .ql-editor ol li.ql-indent-9 {\n    counter-increment: list-9;\n  }\n  .ql-editor ol li.ql-indent-9:before {\n    content: counter(list-9, decimal) '. ';\n  }\n  .ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 3em;\n  }\n  .ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n    padding-left: 4.5em;\n  }\n  .ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 3em;\n  }\n  .ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n    padding-right: 4.5em;\n  }\n  .ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 6em;\n  }\n  .ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n    padding-left: 7.5em;\n  }\n  .ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 6em;\n  }\n  .ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n    padding-right: 7.5em;\n  }\n  .ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 9em;\n  }\n  .ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n    padding-left: 10.5em;\n  }\n  .ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 9em;\n  }\n  .ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n    padding-right: 10.5em;\n  }\n  .ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 12em;\n  }\n  .ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n    padding-left: 13.5em;\n  }\n  .ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 12em;\n  }\n  .ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n    padding-right: 13.5em;\n  }\n  .ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 15em;\n  }\n  .ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n    padding-left: 16.5em;\n  }\n  .ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 15em;\n  }\n  .ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n    padding-right: 16.5em;\n  }\n  .ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 18em;\n  }\n  .ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n    padding-left: 19.5em;\n  }\n  .ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 18em;\n  }\n  .ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n    padding-right: 19.5em;\n  }\n  .ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 21em;\n  }\n  .ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n    padding-left: 22.5em;\n  }\n  .ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 21em;\n  }\n  .ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n    padding-right: 22.5em;\n  }\n  .ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 24em;\n  }\n  .ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n    padding-left: 25.5em;\n  }\n  .ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 24em;\n  }\n  .ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n    padding-right: 25.5em;\n  }\n  .ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 27em;\n  }\n  .ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n    padding-left: 28.5em;\n  }\n  .ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 27em;\n  }\n  .ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n    padding-right: 28.5em;\n  }\n  .ql-editor .ql-video {\n    display: block;\n    max-width: 100%;\n  }\n  .ql-editor .ql-video.ql-align-center {\n    margin: 0 auto;\n  }\n  .ql-editor .ql-video.ql-align-right {\n    margin: 0 0 0 auto;\n  }\n  .ql-editor .ql-bg-black {\n    background-color: #000;\n  }\n  .ql-editor .ql-bg-red {\n    background-color: #e60000;\n  }\n  .ql-editor .ql-bg-orange {\n    background-color: #f90;\n  }\n  .ql-editor .ql-bg-yellow {\n    background-color: #ff0;\n  }\n  .ql-editor .ql-bg-green {\n    background-color: #008a00;\n  }\n  .ql-editor .ql-bg-blue {\n    background-color: #06c;\n  }\n  .ql-editor .ql-bg-purple {\n    background-color: #93f;\n  }\n  .ql-editor .ql-color-white {\n    color: #fff;\n  }\n  .ql-editor .ql-color-red {\n    color: #e60000;\n  }\n  .ql-editor .ql-color-orange {\n    color: #f90;\n  }\n  .ql-editor .ql-color-yellow {\n    color: #ff0;\n  }\n  .ql-editor .ql-color-green {\n    color: #008a00;\n  }\n  .ql-editor .ql-color-blue {\n    color: #06c;\n  }\n  .ql-editor .ql-color-purple {\n    color: #93f;\n  }\n  .ql-editor .ql-font-serif {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-editor .ql-font-monospace {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-editor .ql-size-small {\n    font-size: 0.75em;\n  }\n  .ql-editor .ql-size-large {\n    font-size: 1.5em;\n  }\n  .ql-editor .ql-size-huge {\n    font-size: 2.5em;\n  }\n  .ql-editor .ql-direction-rtl {\n    direction: rtl;\n    text-align: inherit;\n  }\n  .ql-editor .ql-align-center {\n    text-align: center;\n  }\n  .ql-editor .ql-align-justify {\n    text-align: justify;\n  }\n  .ql-editor .ql-align-right {\n    text-align: right;\n  }\n  .ql-editor.ql-blank::before {\n    color: rgba(0,0,0,0.6);\n    content: attr(data-placeholder);\n    font-style: italic;\n    left: 15px;\n    pointer-events: none;\n    position: absolute;\n    right: 15px;\n  }\n  .ql-snow.ql-toolbar:after,\n  .ql-snow .ql-toolbar:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow.ql-toolbar button,\n  .ql-snow .ql-toolbar button {\n    background: none;\n    border: none;\n    cursor: pointer;\n    display: inline-block;\n    float: left;\n    height: 24px;\n    padding: 3px 5px;\n    width: 28px;\n  }\n  .ql-snow.ql-toolbar button svg,\n  .ql-snow .ql-toolbar button svg {\n    float: left;\n    height: 100%;\n  }\n  .ql-snow.ql-toolbar button:active:hover,\n  .ql-snow .ql-toolbar button:active:hover {\n    outline: none;\n  }\n  .ql-snow.ql-toolbar input.ql-image[type=file],\n  .ql-snow .ql-toolbar input.ql-image[type=file] {\n    display: none;\n  }\n  .ql-snow.ql-toolbar button:hover,\n  .ql-snow .ql-toolbar button:hover,\n  .ql-snow.ql-toolbar button:focus,\n  .ql-snow .ql-toolbar button:focus,\n  .ql-snow.ql-toolbar button.ql-active,\n  .ql-snow .ql-toolbar button.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-label:hover,\n  .ql-snow .ql-toolbar .ql-picker-label:hover,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active,\n  .ql-snow.ql-toolbar .ql-picker-item:hover,\n  .ql-snow .ql-toolbar .ql-picker-item:hover,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected {\n    color: #06c;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,\n  .ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {\n    fill: #06c;\n  }\n  .ql-snow.ql-toolbar button:hover .ql-stroke,\n  .ql-snow .ql-toolbar button:hover .ql-stroke,\n  .ql-snow.ql-toolbar button:focus .ql-stroke,\n  .ql-snow .ql-toolbar button:focus .ql-stroke,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,\n  .ql-snow.ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow .ql-toolbar button:focus .ql-stroke-miter,\n  .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,\n  .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,\n  .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {\n    stroke: #06c;\n  }\n  @media (pointer: coarse) {\n    .ql-snow.ql-toolbar button:hover:not(.ql-active),\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) {\n      color: #FFF;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill {\n      fill: #FFF;\n    }\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,\n    .ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,\n    .ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter {\n      stroke: #FFF;\n    }\n  }\n  .ql-snow {\n    box-sizing: border-box;\n  }\n  .ql-snow * {\n    box-sizing: border-box;\n  }\n  .ql-snow .ql-hidden {\n    display: none;\n  }\n  .ql-snow .ql-out-bottom,\n  .ql-snow .ql-out-top {\n    visibility: hidden;\n  }\n  .ql-snow .ql-tooltip {\n    position: absolute;\n    transform: translateY(10px);\n  }\n  .ql-snow .ql-tooltip a {\n    cursor: pointer;\n    text-decoration: none;\n  }\n  .ql-snow .ql-tooltip.ql-flip {\n    transform: translateY(-10px);\n  }\n  .ql-snow .ql-formats {\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-formats:after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n  .ql-snow .ql-stroke {\n    fill: none;\n    stroke: #FFF;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n  .ql-snow .ql-stroke-miter {\n    fill: none;\n    stroke: #FFF;\n    stroke-miterlimit: 10;\n    stroke-width: 2;\n  }\n  .ql-snow .ql-fill,\n  .ql-snow .ql-stroke.ql-fill {\n    fill: #FFF;\n  }\n  .ql-snow .ql-empty {\n    fill: none;\n  }\n  .ql-snow .ql-even {\n    fill-rule: evenodd;\n  }\n  .ql-snow .ql-thin,\n  .ql-snow .ql-stroke.ql-thin {\n    stroke-width: 1;\n  }\n  .ql-snow .ql-transparent {\n    opacity: 0.4;\n  }\n  .ql-snow .ql-direction svg:last-child {\n    display: none;\n  }\n  .ql-snow .ql-direction.ql-active svg:last-child {\n    display: inline;\n  }\n  .ql-snow .ql-direction.ql-active svg:first-child {\n    display: none;\n  }\n  .ql-snow .ql-editor h1 {\n    font-size: 2em;\n  }\n  .ql-snow .ql-editor h2 {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-editor h3 {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-editor h4 {\n    font-size: 1em;\n  }\n  .ql-snow .ql-editor h5 {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-editor h6 {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-editor a {\n    text-decoration: underline;\n  }\n  .ql-snow .ql-editor blockquote {\n    border-left: 4px solid #ccc;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding-left: 16px;\n  }\n  .ql-snow .ql-editor code,\n  .ql-snow .ql-editor pre {\n    background-color: #f0f0f0;\n    border-radius: 3px;\n  }\n  .ql-snow .ql-editor pre {\n    white-space: pre-wrap;\n    margin-bottom: 5px;\n    margin-top: 5px;\n    padding: 5px 10px;\n  }\n  .ql-snow .ql-editor code {\n    font-size: 85%;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-editor pre.ql-syntax {\n    background-color: #23241f;\n    color: #f8f8f2;\n    overflow: visible;\n  }\n  .ql-snow .ql-editor img {\n    max-width: 100%;\n  }\n  .ql-snow .ql-picker {\n    color: #FFF;\n    display: inline-block;\n    float: left;\n    font-size: 14px;\n    font-weight: 500;\n    height: 24px;\n    position: relative;\n    vertical-align: middle;\n  }\n  .ql-snow .ql-picker-label {\n    cursor: pointer;\n    display: inline-block;\n    height: 100%;\n    padding-left: 8px;\n    padding-right: 2px;\n    position: relative;\n    width: 100%;\n  }\n  .ql-snow .ql-picker-label::before {\n    display: inline-block;\n    line-height: 22px;\n  }\n  .ql-snow .ql-picker-options {\n    background-color: #293742;\n    display: none;\n    min-width: 100%;\n    padding: 4px 8px;\n    position: absolute;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-picker-options .ql-picker-item {\n    cursor: pointer;\n    display: block;\n    padding-bottom: 5px;\n    padding-top: 5px;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    color: #ccc;\n    z-index: 2;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {\n    fill: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {\n    stroke: #ccc;\n  }\n  .ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    display: block;\n    margin-top: -1px;\n    top: 100%;\n    z-index: 1;\n  }\n  .ql-snow .ql-color-picker,\n  .ql-snow .ql-icon-picker {\n    width: 28px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label,\n  .ql-snow .ql-icon-picker .ql-picker-label {\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-label svg,\n  .ql-snow .ql-icon-picker .ql-picker-label svg {\n    right: 4px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-options {\n    padding: 4px 0px;\n  }\n  .ql-snow .ql-icon-picker .ql-picker-item {\n    height: 24px;\n    width: 24px;\n    padding: 2px 4px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-options {\n    padding: 3px 5px;\n    width: 152px;\n  }\n  .ql-snow .ql-color-picker .ql-picker-item {\n    border: 0px solid transparent;\n    float: left;\n    height: 16px;\n    margin: 2px;\n    padding: 0px;\n    width: 16px;\n  }\n  .ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n    position: absolute;\n    margin-top: -9px;\n    right: 0;\n    top: 50%;\n    width: 18px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {\n    content: attr(data-label);\n  }\n  .ql-snow .ql-picker.ql-header {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    content: 'Heading 1';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    content: 'Heading 2';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    content: 'Heading 3';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    content: 'Heading 4';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    content: 'Heading 5';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    content: 'Heading 6';\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before {\n    font-size: 2em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before {\n    font-size: 1.5em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before {\n    font-size: 1.17em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before {\n    font-size: 1em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before {\n    font-size: 0.83em;\n  }\n  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before {\n    font-size: 0.67em;\n  }\n  .ql-snow .ql-picker.ql-font {\n    width: 108px;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item::before {\n    content: 'Sans Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    content: 'Serif';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    content: 'Monospace';\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {\n    font-family: Georgia, Times New Roman, serif;\n  }\n  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {\n    font-family: Monaco, Courier New, monospace;\n  }\n  .ql-snow .ql-picker.ql-size {\n    width: 98px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item::before {\n    content: 'Normal';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    content: 'Small';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    content: 'Large';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    content: 'Huge';\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {\n    font-size: 10px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {\n    font-size: 18px;\n  }\n  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {\n    font-size: 32px;\n  }\n  .ql-snow .ql-color-picker.ql-background .ql-picker-item {\n    background-color: #fff;\n  }\n  .ql-snow .ql-color-picker.ql-color .ql-picker-item {\n    background-color: #000;\n  }\n  .ql-toolbar.ql-snow {\n    border: 0px solid #ccc;\n    background-color: #394b59!important;\n    box-sizing: border-box;\n    font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;\n    padding: 8px;\n  }\n  .ql-toolbar.ql-snow .ql-formats {\n    margin-right: 15px;\n  }\n  .ql-toolbar.ql-snow .ql-picker-label {\n    border: 0px solid transparent;\n  }\n  .ql-toolbar.ql-snow .ql-picker-options {\n    border: 0px solid transparent;\n    box-shadow: rgba(0,0,0,0.2) 0 2px 8px;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n    border-color: #ccc;\n  }\n  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {\n    border-color: #ccc;\n  }\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,\n  .ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {\n    border-color: #000;\n  }\n  .ql-toolbar.ql-snow + .ql-container.ql-snow {\n    border-top: 0px;\n  }\n  .ql-snow .ql-tooltip {\n    background-color: #293742;\n    border: 0px solid #ccc;\n    box-shadow: 0px 0px 5px #ddd;\n    color: #FFF;\n    padding: 5px 12px;\n    white-space: nowrap;\n  }\n  .ql-snow .ql-tooltip::before {\n    content: \"Visit URL:\";\n    line-height: 26px;\n    margin-right: 8px;\n  }\n  .ql-snow .ql-tooltip input[type=text] {\n    display: none;\n    border: 0px solid #ccc;\n    font-size: 13px;\n    height: 26px;\n    margin: 0px;\n    padding: 3px 5px;\n    width: 170px;\n  }\n  .ql-snow .ql-tooltip a.ql-preview {\n    display: inline-block;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top;\n  }\n  .ql-snow .ql-tooltip a.ql-action::after {\n    border-right: 1px solid #ccc;\n    content: 'Edit';\n    margin-left: 16px;\n    padding-right: 8px;\n  }\n  .ql-snow .ql-tooltip a.ql-remove::before {\n    content: 'Remove';\n    margin-left: 8px;\n  }\n  .ql-snow .ql-tooltip a {\n    line-height: 26px;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-preview,\n  .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n    display: none;\n  }\n  .ql-snow .ql-tooltip.ql-editing input[type=text] {\n    display: inline-block;\n  }\n  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {\n    border-right: 0px;\n    content: 'Save';\n    padding-right: 0px;\n  }\n  .ql-snow .ql-tooltip[data-mode=link]::before {\n    content: \"Enter link:\";\n  }\n  .ql-snow .ql-tooltip[data-mode=formula]::before {\n    content: \"Enter formula:\";\n  }\n  .ql-snow .ql-tooltip[data-mode=video]::before {\n    content: \"Enter video:\";\n  }\n  .ql-snow a {\n    color: #06c;\n  }\n  .ql-container.ql-snow {\n    border: 0px solid #ccc;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
